import { FC, useEffect } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import DatePicker from "../../shared/base-components/DatePicker";
import { useCustomerMaintenanceUpdateMutation } from "./CustomerProfile.actions";
import { CustomerProfileResponse } from "./CustomerProfile.constants";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getItem } from "../../shared/hooks/useCookie";
import { RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";

interface CustomerUpdateModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  profilData: CustomerProfileResponse | undefined;
  mutate: UseMutateFunction<
    CustomerProfileResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

const CustomerUpdateModal: FC<CustomerUpdateModalProps> = ({
  isModalOpen,
  toggle,
  profilData,
  mutate,
}) => {
  const customerProfileId = getItem("customerProfileId");

  const {
    data,
    mutate: customerMaintenanceUpdate,
    isLoading,
  } = useCustomerMaintenanceUpdateMutation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>();

  const onSubmit: SubmitHandler<any> = (requestFormValues) => {
    customerMaintenanceUpdate({
      ...requestFormValues,
      maintenanceId: profilData?.maintenances[0]?.id,
      customer_device: profilData?.customer_devices[0]?.id,
    });
  };

  useEffect(() => {
    if (data) {
      mutate({ id: customerProfileId });
      successNotify("Güncelleme başarılı!");
      toggle();
    }
  }, [data]);

  return (
    <ModalComponent
      header="Bakım Güncelleme"
      description="Bakım güncellemek için gerekli alanları doldurunuz."
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Not</Label>
              <TextField
                control={control}
                name="note"
                className="form-control"
                type="text"
                defaultValue={
                  profilData?.maintenances[0]?.note
                    ? profilData?.maintenances[0]?.note
                    : undefined
                }
                placeholder="Not"
                // error={errors.note?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Sonraki Bakım Tarihi</Label>
              <DatePicker
                control={control}
                name="next_maintenance_date"
                className="form-control"
                defaultValue={
                  profilData?.maintenances[0].next_maintenance_date
                    ? profilData?.maintenances[0].next_maintenance_date
                    : undefined
                }
                // error={errors.next_maintenance_date?.message}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isLoading}
                text="Bakım Güncelle"
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CustomerUpdateModal;
